export default {"src":"/_next/static/image/public/images/ic_upload_prescription.1a0facb7620b4d3440088a015bb83d4c.svg","height":61,"width":55};